module.exports = __webpack_public_path__ + "img/share.6894a327.svg";